import * as React from 'react'
import { createPortal } from 'react-dom'
import { styled } from 'next-yak'

import * as type from '../type'

import { OptionsModal } from './OptionsModal'
import { Card } from './RewardCard'

function RewardCardComponent({ className, ...rewardProps }: type.RewardCardProps): React.ReactElement<any> {
  const [isModalOpen, setIsModalOpen] = React.useState(false)

  const options = rewardProps.isMultiVariationsEnabled ? rewardProps.reward.options : rewardProps.reward.variants

  const hasOptions = Boolean(options && options.length > 0)

  return (
    <div className={className}>
      <Card
        {...rewardProps}
        onSelect={{
          ...rewardProps.onSelect,
          reward: () => {
            if (hasOptions) {
              setIsModalOpen(true)
            } else {
              rewardProps.onSelect.reward()
            }
          },
        }}
      />

      {rewardProps.usePortalForModal ? (
        <>
          {createPortal(
            <OptionsModal
              {...rewardProps}
              onClose={(id) => {
                setIsModalOpen(false)
                if (id) {
                  rewardProps?.onSelect.variant?.(id)
                }
              }}
              open={isModalOpen}
            />,
            document.body,
          )}
        </>
      ) : (
        <OptionsModal
          {...rewardProps}
          onClose={(id, optionValuesIds, resolvedVariantId) => {
            setIsModalOpen(false)
            if (id && optionValuesIds) {
              rewardProps?.onSelect.variant?.(id, optionValuesIds, resolvedVariantId)
            } else if (id) {
              rewardProps?.onSelect.variant?.(id)
            }
          }}
          open={isModalOpen}
        />
      )}
    </div>
  )
}

export const RewardCard = styled(RewardCardComponent)``
export { OptionCard } from './OptionsModal'
